module.exports = __webpack_public_path__ + "static/media/loader.3ec14355.gif";